import { string } from 'prop-types';
import React, { PureComponent, Fragment } from 'react';
import classnames from 'classnames';
import Pinterest from 'components/Icons/Pinterest';
import PinterestWidgetLib from 'components/PinterestWidgetLib';
import { MQ_MEDIUM_ONLY } from 'constants/mq';
import { addTrackingParams } from './helpers';

/**
 * this component implements a Pinterest 'Save Button' for a given image.
 *
 * see https://developers.pinterest.com/docs/widgets/save/
 *
 * also see https://github.com/pinterest/widgets/blob/master/pinit_main.js for
 * source to pinit.js file and some docs on their public `PinUtils` API.
 */
class PinItButton extends PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    const { pageUrl, imageUrl, description } = this.props;
    // TODO: fallback URL if PinUtils is not defined
    if (window.PinUtils) {
      window.PinUtils.pinOne({
        url: addTrackingParams(pageUrl),
        media: imageUrl,
        description
      });
    }
  }

  render() {
    const { description, imageUrl, pageUrl, placement, variant } = this.props;

    const buttonClasses = classnames('PinItButton', {
      [`PinItButton--${variant}`]: variant
    });

    const imageActionsVariant = 'imageActions';

    return (
      <Fragment>
        <a
          className={buttonClasses}
          href="#pinit"
          data-pin-url={addTrackingParams(pageUrl)}
          data-pin-do="buttonPin"
          data-pin-tag={placement}
          data-pin-custom="true"
          data-pin-media={imageUrl}
          data-pin-description={description}
          data-gtm-placement={placement}
          data-gtm-ignore-outbound-link="true"
          onClick={this.handleClick}
        >
          {variant === imageActionsVariant && (
            <Fragment>
              <Pinterest style={{ fill: '#705e5d' }} display="inline-block" />
              <span>Pin It</span>
            </Fragment>
          )}
          {variant !== imageActionsVariant && (
            <div className="PinItButton__button">
              <Pinterest />
            </div>
          )}
        </a>
        <PinterestWidgetLib />
        <style jsx>{`
          .PinItButton {
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 35px;
            height: 35px;
            background-color: #bd081c;
            border: none;
            border-radius: 25px;
            color: #fff;
            font-size: 1.5rem;
          }

          .PinItButton__button {
            pointer-events: none;
          }

          .PinItButton--small {
            width: 32px;
            height: 32px;
            font-size: 1.25rem;
          }

          .PinItButton--imageActions {
            display: flex;
            align-items: center;
            width: auto;
            height: auto;
            background-color: transparent;
            border-radius: 0;
            font-size: 1rem;
          }

          .PinItButton--imageActions span {
            color: #705e5d;
            font-size: 11px;
            font-weight: bold;
            text-transform: uppercase;
            margin-left: 0.15rem;
          }

          @media ${MQ_MEDIUM_ONLY} {
            .PinItButton--imageActions span {
              display: none;
            }
          }
        `}</style>
      </Fragment>
    );
  }
}

PinItButton.defaultProps = {
  description: '',
  variant: undefined
};

PinItButton.propTypes = {
  description: string,
  imageUrl: string.isRequired,
  pageUrl: string.isRequired,
  placement: string.isRequired,
  variant: string
};

export default PinItButton;
